import React, { Component } from "react";
import Layout from "../../components/Layout/Layout";
import PageHeading from "../../components/PageHeading";
import ReporteCrediticio from "../../components/RenderizarReporte/ReporteCrediticio";
import servicioToken from "../../servicios/servicioToken";

class Inicio extends Component {
  render() {
    return (
      servicioToken.obtenerToken() && (
        <Layout>
          <div>
            {/* <!-- Page Heading --> */}
            <PageHeading title="Reporte Crediticio" />
            <ReporteCrediticio />
          </div>
        </Layout>
      )
    );
  }
}

export default Inicio;
